export default "/50f517735fec46580f19aae3e56e9fe21614ea75/5ba84b7c5997e2a9223c26a23a6fa17e.svg";